<template>
    <div id="banner-element" :class="{empty: !moduleData}">
        <div class="module full-height outwards" v-if="moduleData" :class="moduleData.Spacing" :id="moduleData.AnchorID">
            <vue-glide class="quotes" :perView="1" type="carousel" :gap="0" @glide:run="updateActiveSlide">
                <vue-glide-slide v-for="(banner, index) in moduleData.Banners" :key="index">
                    <b-img class="shadow-heavy" v-if="banner.Image && banner.Image.ID" v-bind="imageProps" :src="banner.Image.URL"></b-img>
                    <div class="overlay"></div>
                    <div class="content-holder" :class="banner.ContentPosition">
                        <div class="wrapper">
                            <h2 v-if="banner.Title && banner.ShowTitle">{{banner.Title}}</h2>
                            <p v-if="banner.Content" v-html="banner.Content"></p>
                            <a class="btn btn-dark shadow-heavy" v-if="banner.CTA.ID" :href="banner.CTA.URL">{{banner.CTA.CTAText}}</a>
                        </div>
                    </div>
                </vue-glide-slide>
                <template slot="control">
                    <button class="glide__bullet" v-for="(banner, index) in moduleData.Banners" :key="index" :data-glide-dir="'=' + index" :class="index === activeSlide ? 'active' : ''"></button>
                </template>
            </vue-glide>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import {Glide, GlideSlide} from 'vue-glide-js';

    export default {
        name: "BannerCarouselElement",
        components: {
            [Glide.name]: Glide,
            [GlideSlide.name]: GlideSlide
        },
        data() {
            return {
                imageProps: {
                    center: true,
                    fluidGrow: true
                },
                activeSlide: 0
            }
        },
        props: {
            component: {
                type: Object,
            }
        },
        computed: {
            ...mapGetters(['getModuleData', 'getSettings']),
            moduleData() {
                return this.getModuleData(this.component.ID);
            }
        },
        methods: {
            updateActiveSlide(e) {
                let direction = e.direction,
                    active = this.activeSlide,
                    total = this.moduleData.Banners.length - 1;
                if (direction === '>') {
                    active += 1;
                    if (active > total) {
                        active = 0;
                    }
                } else {
                    active -= 1;
                    if (active < 0) {
                        active = total;
                    }
                }

                this.activeSlide = active;
            }
        }
    }
</script>
